import React from 'react';

export const highlightSearchTerm = (searchTerm: string, text: string) => {
    if (searchTerm) {
        const searchTermRegex = new RegExp(`(${searchTerm})`, 'gi');
        return text
            .split(searchTermRegex)
            .map((segment, i) =>
                searchTermRegex.test(segment) ? (
                    <mark key={`${segment}-${i}`}>{segment}</mark>
                ) : (
                    segment
                )
            );
    }
    return text;
};
